import { takeLatest, call, put, select } from "redux-saga/effects";
import API_ENDPOINTS from "@services/apiConfig";
import 'url-search-params-polyfill';
import axios from 'axios';

export const actionTypes = {
    validateRequest: 'connectShopify/VALIDATE_REQUEST',
    validationFailed: 'connectShopify/VALIDATION_FAILED',
    saveValidationData: 'connectShopify/SAVE_VALIDATION_DATA',
    submitMerchantDetails: 'connectShopify/SUBMIT_MERCHANT_DETAILS',
    submitFailed: 'connectShopify/SUBMIT_FAILED',
    submitSuccess: 'connectShopify/SUBMIT_SUCCESS',
    resetErrorMessage: 'connectShopify/RESET_ERROR_MESSAGE',
};

export const actions = {
    validateRequest: (shopifyParams) => ({
        type: actionTypes.validateRequest,
        payload: shopifyParams,
    }),
    validationFailed: (responseData) => ({
        type: actionTypes.validationFailed,
        payload: responseData
    }),
    saveValidationData: (validationData) => ({
        type: actionTypes.saveValidationData,
        payload: validationData,
    }),
    submitMerchantDetails: (formData) => ({
        type: actionTypes.submitMerchantDetails,
        payload: formData,
    }),
    submitFailed: (errorMessage) => ({
        type: actionTypes.submitFailed,
        payload: errorMessage,
    }),
    submitSuccess: () => ({
        type: actionTypes.submitSuccess,
    }),
    resetErrorMessage: () => ({
        type: actionTypes.resetErrorMessage,
    })
};

const initialState = {
    loading: true,
    validated: false,
    installed: false,
    token: '',
    shopName: '',
    errorMessage: '',
    redirectUrl: '',
    submitted: false,
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.validateRequest: {
            return {
                ...state,
            };
        }
        case actionTypes.validationFailed: {
            return {
                ...state,
                loading: false,
                ...action.payload,
            };
        }
        case actionTypes.saveValidationData: {
            return {
                ...state,
                loading: false,
                ...action.payload,
            };
        }
        case actionTypes.submitMerchantDetails: {
            return {
                ...state,
            };
        }
        case actionTypes.submitFailed: {
            return {
                ...state,
                ...action.payload,
            }
        }
        case actionTypes.submitSuccess: {
            return {
                ...state,
                submitted: true,
            }
        }
        case actionTypes.resetErrorMessage: {
            return {
                ...state,
                errorMessage: '',
            }
        }
        default:
            return state;
    }
};

export const selectors = {
    getLoadingStatus: state => state.partnerApp.connectShopify.loading,
    getValidationStatus: state => state.partnerApp.connectShopify.validated,
    getInstallationStatus: state => state.partnerApp.connectShopify.installed,
    getTokenAndShopName: state => ({
        token: state.partnerApp.connectShopify.token,
        shopName: state.partnerApp.connectShopify.shopName,
    }),
    getErrorMessage: state => state.partnerApp.connectShopify.errorMessage,
    getRedirectUrl: state => state.partnerApp.connectShopify.redirectUrl,
    isSubmitted: state => state.partnerApp.connectShopify.submitted,
};

function* validateRequestWorker(action) {
    try {
        const { payload: queryString } = action;
        const shopifyParams = new URLSearchParams(location.search);
        const {
            data: responseData,
        } = yield call([axios, "post"], API_ENDPOINTS.SHOPIFY.VALIDATE_REQUEST,
            {
                code: shopifyParams.get('code'),
                hmac: shopifyParams.get('hmac'),
                timestamp: shopifyParams.get('timestamp'),
                state: shopifyParams.get('state'),
                shop: shopifyParams.get('shop'),
                queryString: queryString.substring(1),
            }
        );

        yield put({
            type: actionTypes.saveValidationData,
            payload: responseData
        });
    }
    catch (err) {
        const errorMessage = 'Something went wrong. Please try again.',
            validated = false;
        yield put({
            type: actionTypes.validationFailed,
            payload: { errorMessage, validated }
        });
    }
}

async function digestMerchantSalt(merchantSalt) {
    const msgUint8 = new TextEncoder().encode(merchantSalt);                           // encode as (utf-8) Uint8Array
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);           // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer));                     // convert buffer to byte array
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
    return hashHex;
}

function* submitMerchantDetailsWorker(action) {
    try {
        const { payload: formData } = action;
        yield put({
            type: actionTypes.resetErrorMessage,
        });

        const merchantSaltDigestHex = yield call(digestMerchantSalt, formData.merchantSalt);

        const {
            data: responseData,
        } = yield call([axios, "post"], API_ENDPOINTS.SHOPIFY.SUBMIT_MERCHANT_DETAILS,
            {
                merchantKey: formData.merchantKey,
                merchantSalt: merchantSaltDigestHex,
                ...yield select(selectors.getTokenAndShopName),
            }
        );
        yield put({ type: actionTypes.submitSuccess });
        window.open(responseData.redirectUrl).focus();
    }
    catch (err) {
        let errorMessage = 'Something went wrong. Please try again.';
        if (err && err.response && err.response.data && err.response.data.error) {
            errorMessage = err.response.data.error;
        }
        yield put({
            type: actionTypes.submitFailed,
            payload: { errorMessage }
        });
    }
}

export function* saga() {
    yield takeLatest(actionTypes.validateRequest, validateRequestWorker);
    yield takeLatest(actionTypes.submitMerchantDetails, submitMerchantDetailsWorker);
}



